import {useSnackbar} from "notistack";
import {IconButton} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";

export function SnackbarCloseButton({snackbarKey}) {
    const {closeSnackbar} = useSnackbar();
    return (
        <IconButton onClick={() => closeSnackbar(snackbarKey)}>
            <CloseIcon fontSize={"small"} style={{color: '#FFF'}}/>
        </IconButton>
    );
}
